(function () {
    "use strict";

    angular.module("app").component("downloadButton", {
        transclude: true,
        bindings: { attachmentId: "=" },
        template: `<button class="btn btn-primary" ng-click="$ctrl.Download()">
            <i class="fa fa-download"></i> 
            <ng-transclude>{{'Download' | habilTranslation}}</ng-transclude>
        </button>`,
        controller: DownloadButtonController
    });

    DownloadButtonController.$inject = ["downloadService", "loadingIndicatorService"];
    function DownloadButtonController(downloadService, loadingIndicatorService) {

        const vm = this;

        vm.Download = function () {
            downloadService.DownloadAttachmentByPublicId(vm.attachmentId, () => loadingIndicatorService.SetLoadingState(false));
        };
    }
})();
